import { render, staticRenderFns } from "./AddProviderDialog.vue?vue&type=template&id=619d5d32&"
import script from "./AddProviderDialog.vue?vue&type=script&lang=js&"
export * from "./AddProviderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports